import {hashHistory} from "react-router";
import {changeQTRoutePath} from "../../misc/changeRoutePath";
import {getCurrentLayout} from "../appLayout";
import store from "./../../store";
import {
  changeActivePartRelatedItemIndex, setCameFromPage,
  setQtActiveCategory,
  toggleBathroomVisualizerOpen,
  toggleSelectionWindow
} from "../../actions/actionFunctions";
import Config from "../../config";
import {switchToWizardItem} from "../qkbPages/materialsWizard/useChangeWizardStepRoute";

export default (cameFromPage, firstCat = false, subPart = null, qtCategoryName = "", wizardAllObject = null, stepIndex = 0) => {
  const layout = getCurrentLayout();
  const state = store.getState();
  const {selectionGroup, activePartRelatedItemIndex} = state.selectionState;
  const layoutParts = state.stepsState.layoutParts;
  const qtActiveCategory = qtCategoryName || (subPart && subPart.part ? subPart.part.qtCategoryName : state.qtState.qtActiveCategory);

  store.dispatch(toggleSelectionWindow(true, selectionGroup || layoutParts[0]));
  store.dispatch(toggleBathroomVisualizerOpen(false));
  store.dispatch(setCameFromPage(cameFromPage));

  const {wizardList, wizardIsActive} = state.wizardState;
  if (wizardAllObject) {
    const {wizardItemId, quoteIndex} = wizardAllObject;
    const wizardItem = wizardList.find(wizItem => wizItem.id === wizardItemId); // if not found - set default
    switchToWizardItem(wizardItem, stepIndex, quoteIndex);
    return
  } else if (wizardIsActive) {
    switchToWizardItem();
    return
  }

  if (layout.qtCategories) { // set default if index is not matching
    let currentActiveCategory = layout.qtCategories.find(qtCat => qtCat.name === qtActiveCategory);
    if (subPart) {
      if (!currentActiveCategory) { // edge profile cases
        currentActiveCategory = layout.qtCategories.find(qtCat => qtCat.subParts.some(sPart => sPart.part.partId === subPart.part.partId));
      }
      if (!currentActiveCategory) { // edge profile cases
        if (Config.isDevMode()) {
          console.log("NO CATEGORY for feature", );
        }
        if (layout.qtCategories.length) {
          store.dispatch(setQtActiveCategory(layout.qtCategories[0].name));
          store.dispatch(changeActivePartRelatedItemIndex(0));
          changeQTRoutePath(layout.qtCategories[0].name, 0);
        } else {
          if (!window.location.href.includes('materials')) {
            hashHistory.push('materials');
          }
        }
        return;
      }
      const relatedItemIndex = currentActiveCategory.subParts.findIndex(subPartItem => {
        return subPartItem.part.partId === subPart.part.partId
      });
      store.dispatch(setQtActiveCategory(currentActiveCategory.name));
      store.dispatch(changeActivePartRelatedItemIndex(relatedItemIndex > -1 ? relatedItemIndex : 0));
      changeQTRoutePath(currentActiveCategory.name, relatedItemIndex);
    } else if (!currentActiveCategory || !currentActiveCategory.subParts[activePartRelatedItemIndex] || firstCat) {
      const qtCategory = layout.qtCategories[0];
      store.dispatch(setQtActiveCategory(qtCategory.name));
      store.dispatch(changeActivePartRelatedItemIndex(0));
      changeQTRoutePath(qtCategory.name, 0);
    }
  }

  if (!window.location.href.includes('materials')) {
    hashHistory.push('materials');
  }

};
